import React, { Component } from "react";
import { Container } from "react-bootstrap";
import SideNavbar from "../components/navbars/SideNavbar";
import NavbarOne from "../components/navbars/NavbarOne";
import Footer from "../components/footer/Footer";
import * as Cookies from "es-cookie";
import { withRouter } from "react-router-dom";
import { isBrowser } from "react-device-detect";
import CampaignDashboard from "../components/WhatsappCampaignManager/CampaignDashboard";

class WhatsappCampaigns extends Component {
    constructor(props) {
        super(props);
        this.state = {
            toggled: Cookies.get("toggle") || "wrapper"
        };
    }

    menuToggler = () => {
        const { toggled } = this.state;
        if (toggled === "wrapper") {
            this.setState({ toggled: "wrapper sidebar-enable" });
            Cookies.set("toggle", "wrapper sidebar-enable");
        } else {
            this.setState({ toggled: "wrapper" });
            Cookies.set("toggle", "wrapper");
        }
    };

    render() {
        if (Cookies.get("token") === undefined) this.props.history.push("/login");

        return (
            <div className={this.state.toggled}>
                <div className="header-area">
                    <NavbarOne onClick={() => this.menuToggler()} />
                </div>
                <div className="main-wrapper">
                    <div
                        id="sidebar"
                        className={
                            isBrowser === true
                                ? "sidebar-menu d-none d-xl-block d-lg-block"
                                : "sidebar-menu d-block d-xl-none d-lg-none"
                        }
                    >
                        <SideNavbar onClick={() => this.menuToggler()} />
                    </div>
                    <div
                        className="student-overlay"
                        onClick={() => this.menuToggler()}
                    />
                    <div
                        className="content-wrapper pt-4"
                        style={{ minHeight: "100vh", backgroundColor: '#f8fafc' }}
                    >
                        <Container fluid>
                            <CampaignDashboard />
                        </Container>
                    </div>
                    <Footer />
                </div>
            </div>
        );
    }
}

export default withRouter(WhatsappCampaigns);
